import { useState, useRef } from "react";
import axios from "axios";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export default function StockBalanceNetWtReport() {

const [fromDate,setFromDate]=useState("");
const [toDate,setToDate]=useState("");
const [data,setData]=useState([]);

const [companyFilter,setCompanyFilter]=useState("");
const [productFilter,setProductFilter]=useState("");
const [warehouseFilter,setWarehouseFilter]=useState("");
const [varietyFilter,setVarietyFilter]=useState("");
const [stackFilter,setStackFilter]=useState("");
const [blVesselFilter, setblVesselFilter] = useState("");
const [summary, setSummary] = useState({});
const openingStock =
Number(summary?.openingStock || 0);

const totalInward =
Number(summary?.inwardTotal || 0);

const totalOutward =
Number(summary?.outwardTotal || 0);

const availableStock =
openingStock + totalInward - totalOutward;

const tableRef=useRef();


/* FETCH REPORT */

/*const fetchReport=async()=>{

/*if(!fromDate||!toDate){
alert("Please select date range");
return;
}*/
/*if(!fromDate && !toDate){
console.log("Loading full report");
}

try{

const res=await axios.get(
"https://irc.zentelex.com/api/reports/stock-balance-netwt",
{
params:{
fromDate,
toDate,
product:productFilter,
companyName:companyFilter,
warehouse:warehouseFilter,
variety:varietyFilter,
stack:stackFilter
}
}
);

setData(res.data.data||[]);

}catch(err){
alert("Failed to load report");
}

};*/

/*
const fetchReport = async () => {

  if (!fromDate || !toDate) {
    alert("Please select date range");
    return;
  }

  try {

    const token = sessionStorage.getItem("token");
    console.log("TOKEN:", token);
    const res = await axios.get(
      "https://irc.zentelex.com/api/reports/stock-balance-netwt",
      {
        params: {
          fromDate,
          toDate,
          product: productFilter,
          companyName: companyFilter,
          warehouse: warehouseFilter,
          variety: varietyFilter,
          stack: stackFilter
        },
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );

    console.log("API RESPONSE:", res.data); // 🔥 DEBUG

    setData(res.data.data || []);

  } catch (err) {
    if (err.response?.status === 401) {
      alert("Session expired. Please login again");
      sessionStorage.clear();
      window.location.href = "/login";
      return;
    }

    alert("Failed to load report");
  }
};*/


const fetchReport = async () => {
  if (!fromDate || !toDate) {
    alert("Please select date range");
    return;
  }

  try {
    const token = sessionStorage.getItem("token");

    const res = await axios.get(
      "https://irc.zentelex.com/api/reports/stock-balance-netwt",
      {
        params: {
          fromDate,
          toDate,
          product: productFilter,
          companyName: companyFilter,
          warehouse: warehouseFilter,
          variety: varietyFilter,
          stack: stackFilter,
        },
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );

//    console.log("API RESPONSE:", res.data);
    
    const result = res.data;
    
    console.log("API RESPONSE FULL", JSON.stringify(result, null, 2));
    console.log("OPENING ROWS", result?.openingRows?.length);
    console.log("INWARD DETAILS", result?.inwardDetails?.length);
    console.log("OUTWARD DETAILS", result?.outwardDetails?.length);    

    
    setSummary(result.summary || {});
    
    // Merge inward + outward for table display

    const inwardRows = (result.inwardDetails || []).map((row) => ({
  date: row.receiptDate,
  companyName: row.clientName,
  warehouse: row.warehouseName,
  product: row.commodityName,
  variety: row.variety,
  crdNo: row.crd_no,
  cddNo: "",
  truckNo: (() => {
  try {
    const trucks =
      typeof row.truck_details === "string"
        ? JSON.parse(row.truck_details)
        : row.truck_details || [];

    return Array.isArray(trucks) && trucks.length > 0
      ? trucks.map(t => t.truckNo).filter(Boolean).join(", ")
      : "-";
  } catch (e) {
    return "-";
  }
})(),
  totalTrucks: (() => {
  try {
    const trucks =
      typeof row.truck_details === "string"
        ? JSON.parse(row.truck_details)
        : row.truck_details || [];

    return Array.isArray(trucks) ? trucks.length : 0;
  } catch (e) {
    return 0;
  }
})(),
  inwardBags: row.noOfBags || 0,
  inwardNetWt: row.quantityMT || 0,
  outwardBags: 0,
  outwardNetWt: 0,
  closingBags: 0,
  closingNetWt: 0,
  miscellaneous: row.remarks || "",
  spillageBag: 0
}));

    const outwardRows = (result.outwardDetails || []).map((row) => ({
  date: row.document_date,
  companyName: row.client_name,
  warehouse: row.warehouse_name,
  product: row.commodity_name,
  variety: row.variety,
  blVessel: row.bl_vessel_no || "",
  crdNo: "",
  cddNo: row.cdd_no,
  truckNo: (() => {
  try {
    const trucks =
      typeof row.truck_details === "string"
        ? JSON.parse(row.truck_details)
        : row.truck_details || [];

    return Array.isArray(trucks) && trucks.length > 0
      ? trucks.map(t => t.truckNo).filter(Boolean).join(", ")
      : "-";
  } catch (e) {
    return "-";
  }
})(),  
  totalTrucks: (() => {
  try {
    const trucks =
      typeof row.truck_details === "string"
        ? JSON.parse(row.truck_details)
        : row.truck_details || [];

    return Array.isArray(trucks) ? trucks.length : 0;
  } catch (e) {
    return 0;
  }
})(),
  inwardBags: 0,
  inwardNetWt: 0,
  outwardBags: row.no_of_pack || 0,
  outwardNetWt: row.weight_mt || 0,
  closingBags: 0,
  closingNetWt: 0,
  miscellaneous: row.remarks || "",
  spillageBag: 0
}));
   
//   const finalRows = [...inwardRows, ...outwardRows];
 const openingRows = result?.openingRows || [];

const finalRows = [
  ...openingRows,
  ...inwardRows,
  ...outwardRows
]; 
 const openingBags =
 Number(result?.summary?.openingBags || 0);

const openingStock =
 Number(result?.summary?.openingStock || 0);

/*if (finalRows.length > 0) {
  finalRows[finalRows.length - 1].closingNetWt =
    Number(result?.summary?.closingStock || 0);

  finalRows[finalRows.length - 1].closingBags =
    Number(result?.summary?.inwardBags || 0) -
    Number(result?.summary?.outwardBags || 0);
}*/
  // ✅ SORT FIRST
finalRows.sort((a, b) => new Date(a.date) - new Date(b.date));


const balances = {};

finalRows.forEach((row) => {

  // Normalize the stock key
  // Client + Warehouse + Commodity + Variety
  const key =
    `${(row.companyName || "").trim()}|` +
    `${(row.warehouse || "").trim()}|` +
    `${(row.product || "").trim()}|` +
    `${(row.variety || "").trim()}`;

  // Initialize from backend opening balance.
  // This happens only once for each stock key.
  if (!balances[key]) {

    balances[key] = {
      bags: Number(row.openingBags || 0),
      qty: Number(row.openingStock || 0)
    };

  }

  // Opening balance for this transaction row
  row.openingBags = balances[key].bags;
  row.openingStock = balances[key].qty;

  // Current-period inward
  balances[key].bags +=
    Number(row.inwardBags || 0);

  balances[key].qty +=
    Number(row.inwardNetWt || 0);

  // Current-period outward
  balances[key].bags -=
    Number(row.outwardBags || 0);

  balances[key].qty -=
    Number(row.outwardNetWt || 0);

  // Closing balance
  // Business Rule: Closing Bags and Closing MT must never be negative.
  row.closingBags = Math.max(0, balances[key].bags);
  row.closingNetWt = Math.max(0, balances[key].qty);

});

// ✅ START FROM OPENING (important)
//let runningBags = 0;
/*let runningBags =
 Number(result?.summary?.openingBags || 0);

let runningQty =
 Number(result?.summary?.openingStock || 0);
// ⚠️ You DON'T have openingBags from backend yet
// so bags will still be approximate unless backend is fixed

finalRows.forEach((row) => {
    row.openingBags = openingBags;
    row.openingStock = openingStock;
    runningBags =
    runningBags +
    Number(row.inwardBags || 0) -
    Number(row.outwardBags || 0);

  runningQty =
    runningQty +
    Number(row.inwardNetWt || 0) -
    Number(row.outwardNetWt || 0);

  row.closingBags = runningBags;
  row.closingNetWt = runningQty;
});*/
 
console.log("FINAL ROWS COUNT", finalRows.length);
console.log("AVAILABLE STOCK", result.summary?.openingStock);
console.log("FIRST ROW", finalRows[0]);

setData(finalRows);


  } catch (err) {
    console.error(err);

    if (err.response?.status === 401) {
      alert("Session expired. Please login again");
      sessionStorage.clear();
      window.location.href = "/login";
      return;
    }

    alert("Failed to load report");
  }
};


/* FILTER VALUES */

const uniqueProducts=[...new Set(data.map(d=>d.product).filter(Boolean))];
const uniqueCompanies=[...new Set(data.map(d=>d.companyName).filter(Boolean))];
const uniqueWarehouses=[...new Set(data.map(d=>d.warehouse).filter(Boolean))];
const uniqueVarieties=[...new Set(data.map(d=>d.variety).filter(Boolean))];
const uniqueVessels = [
  ...new Set(
    data
      .map(d => d.blVessel)
      .filter(v => v && v.trim() !== "")
  )
];
//const uniqueStacks=[...new Set(data.map(d=>d.stack).filter(Boolean))];
const uniqueStacks=[];

const filteredData=data.filter(row=>(

(productFilter?row.product===productFilter:true)&&
(companyFilter
  ? row.companyName?.toLowerCase().includes(companyFilter.toLowerCase())
  : true) &&
(warehouseFilter?row.warehouse===warehouseFilter:true)&&
(varietyFilter?row.variety===varietyFilter:true)&&
(stackFilter?row.stack===stackFilter:true)&&
(blVesselFilter
 ? row.blVessel === blVesselFilter
 : true)

));


// Total Moisture Gain: absolute sum of negative Opening MT values
const moistureGain = filteredData.reduce((total, row) => {
  const openingMT = Number(row.openingStock || 0);
  return Number.isFinite(openingMT) && openingMT < 0
    ? total + Math.abs(openingMT)
    : total;
}, 0);


/* STOCK */


const handlePrint=()=>{

const printContents=tableRef.current.innerHTML;

const win=window.open("","","width=1200,height=800");

win.document.write(`
<html>
<head>
<title>Stock Report</title>
<style>
body{font-family:Arial;padding:20px}
table{width:100%;border-collapse:collapse}
th,td{border:1px solid #ddd;padding:8px;text-align:center}
th{background:#0d6efd;color:white}
</style>
</head>
<body>
<h3>Stock Balance Report</h3>
${printContents}
</body>
</html>
`);

win.document.close();
win.print();

};


/* EXPORT EXCEL */

const handleExportExcel=()=>{

const exportData=filteredData.map((row,i)=>({

"Sl No":i+1,
Date:row.date,
Client:row.companyName,
Warehouse:row.warehouse,
Commodity:row.product,
Variety:row.variety,
Trucks:row.totalTrucks,
Document:`${row.crdNo||"-"} / ${row.cddNo||"-"}`,
"Opening Bags":row.openingBags,
"Opening MT":row.openingStock,
"Inward Bags":row.inwardBags,
"Inward MT":row.inwardNetWt,
"Outward Bags":row.outwardBags,
"Outward MT":row.outwardNetWt,
"Closing Bags":row.closingBags,
"Closing MT":row.closingNetWt,
"Spillage":row.spillageBag || 0,
"Remarks":row.miscellaneous || ""
}));

const ws=XLSX.utils.json_to_sheet(exportData);
const wb=XLSX.utils.book_new();

XLSX.utils.book_append_sheet(wb,ws,"Stock Report");

const buffer=XLSX.write(wb,{bookType:"xlsx",type:"array"});

saveAs(
new Blob([buffer]),
`Stock_Report_${fromDate}_to_${toDate}.xlsx`
);

};


/* CLIENT REPORT */

const handleClientReport=()=>{

const wb=XLSX.utils.book_new();

/* INWARD */

const inward=filteredData
.filter(r=>Number(r.inwardBags)>0)
.map((r,i)=>({

"Sr No":i+1,
Date:r.date,
Client:r.companyName,
Warehouse:r.warehouse,
Commodity:r.product,
Variety:r.variety,
"Truck No":r.truckNo|| r.truck || "",
"CRD No":r.crdNo||"",
"Inward Bags":r.inwardBags,
"Inward Quantity(MT)":Number(r.inwardNetWt||0).toFixed(3),
"Spillage Bag":r.spillageBag || 0,
"Average Wt": r.inwardBags
? (Number(r.inwardNetWt)/Number(r.inwardBags)).toFixed(2)
:"",
Remarks:r.miscellaneous || ""
}));

XLSX.utils.book_append_sheet(
wb,
XLSX.utils.json_to_sheet(inward),
"INWARD"
);


/* OUTWARD */

const outward=filteredData
.filter(r=>Number(r.outwardBags)>0)
.map((r,i)=>({

"Sr No":i+1,
Date:r.date,
Client:r.companyName,
Warehouse:r.warehouse,
Commodity:r.product,
Variety:r.variety,
"Truck No":r.truckNo|| r.truck || "",
"CDD No":r.cddNo||"",
"Outward Bags":r.outwardBags,
"Outward Quantity(MT)":Number(r.outwardNetWt||0).toFixed(3),
"Average Wt": r.outwardBags
? (Number(r.outwardNetWt)/Number(r.outwardBags)).toFixed(2)
:"",
Remarks:r.miscellaneous || ""
}));

XLSX.utils.book_append_sheet(
wb,
XLSX.utils.json_to_sheet(outward),
"OUTWARD"
);


/* SUMMARY */

const summary=filteredData.map((r,i)=>({

"Sr No":i+1,
Date:r.date,
Client:r.companyName,	
Warehouse:r.warehouse,
Commodity:r.product,
Variety:r.variety,
Trucks:r.totalTrucks,
"CRD/CDD No":
r.cddNo && r.cddNo!=="0"
? r.cddNo
: r.crdNo && r.crdNo!=="0"
? r.crdNo
: "",
"Opening Bags":r.openingBags,
"Opening Quantity (MT)":Number(r.openingStock||0).toFixed(3),
"Inward Bags":r.inwardBags,
"Inward Quantity (MT)":Number(r.inwardNetWt||0).toFixed(3),
"Outward Bags":r.outwardBags,
"Outward Quantity (MT)":Number(r.outwardNetWt||0).toFixed(3),
"Spillage Bag":r.spillageBag || 0,
"Closing Bags":r.closingBags,
"Closing Quantity (MT)":Number(r.closingNetWt||0).toFixed(3),
Remarks:r.miscellaneous || ""
}));

XLSX.utils.book_append_sheet(
wb,
XLSX.utils.json_to_sheet(summary),
"SUMMARY"
);

const buffer=XLSX.write(wb,{bookType:"xlsx",type:"array"});

saveAs(
new Blob([buffer]),
`Client_Report_${fromDate}_to_${toDate}.xlsx`
);

};


/* UI */

return(

<div className="container-fluid py-4">

{/* HEADER */}

<div className="card shadow-lg border-0 mb-4 bg-primary text-white">
<div className="card-body">
<h4 className="fw-bold">📦 Stock Balance Report (Net Weight)</h4>
</div>
</div>


{/* ADVANCED FILTERS */}

<div className="card shadow-sm border-0 mb-3">

<div className="card-header bg-primary text-white fw-bold">
Advanced Filters
</div>

<div className="card-body">

<div className="row">

<div className="col-md-2">
<label>Warehouse</label>
<select className="form-select"
value={warehouseFilter}
onChange={e=>setWarehouseFilter(e.target.value)}>
<option value="">All Warehouses</option>
{uniqueWarehouses.map((w,i)=><option key={i}>{w}</option>)}
</select>
</div>

<div className="col-md-2">
<label>Company</label>
<select className="form-select"
value={companyFilter}
onChange={e=>setCompanyFilter(e.target.value)}>
<option value="">All Companies</option>
{uniqueCompanies.map((c,i)=><option key={i}>{c}</option>)}
</select>
</div>

<div className="col-md-2">
<label>Stack</label>
<select className="form-select"
value={stackFilter}
onChange={e=>setStackFilter(e.target.value)}>
<option value="">All Stacks</option>
{uniqueStacks.map((s,i)=><option key={i}>{s}</option>)}
</select>
</div>

<div className="col-md-3">
<label>Commodity</label>
<select className="form-select"
value={productFilter}
onChange={e=>setProductFilter(e.target.value)}>
<option value="">All Commodity</option>
{uniqueProducts.map((p,i)=><option key={i}>{p}</option>)}
</select>
</div>

<div className="col-md-3">
<label>Variety</label>
<select className="form-select"
value={varietyFilter}
onChange={e=>setVarietyFilter(e.target.value)}>
<option value="">All Varieties</option>
{uniqueVarieties.map((v,i)=><option key={i}>{v}</option>)}
</select>
</div>

<div className="col-md-3">
<label>BL No/Vessel Name</label>
<select
 className="form-select"
 value={blVesselFilter}
 onChange={e=>setblVesselFilter(e.target.value)}
>
<option value="">All Vessel</option>
{uniqueVessels.map((v,i)=>(
<option key={i}>{v}</option>
))}
</select>
</div>

</div>

</div>

</div>


{/* DATE FILTER */}

<div className="card shadow-sm border-0 mb-4 bg-light">

<div className="card-body">

<div className="row">

<div className="col-md-3">
<label>From Date</label>
<input type="date"
className="form-control"
value={fromDate}
onChange={e=>setFromDate(e.target.value)}
/>
</div>

<div className="col-md-3">
<label>To Date</label>
<input type="date"
className="form-control"
value={toDate}
onChange={e=>setToDate(e.target.value)}
/>
</div>

<div className="col-md-2 d-flex align-items-end">
<button className="btn btn-primary w-100"
onClick={fetchReport}>
Generate
</button>
</div>

</div>

</div>

</div>


{/* TABLE */}

<div ref={tableRef}>

<div className="row row-cols-1 row-cols-md-5 g-3 mb-4">

<div className="col">
<div className="alert alert-info text-center fw-bold mb-0">
<div>Opening Stock</div>
<div className="fs-4">
{openingStock.toFixed(3)} MT
</div>
</div>
</div>

<div className="col">
<div className="alert alert-success text-center fw-bold mb-0">
<div>Total Inward</div>
<div className="fs-4">
{totalInward.toFixed(3)} MT
</div>
</div>
</div>

<div className="col">
<div className="alert alert-warning text-center fw-bold mb-0">
<div>Total Outward</div>
<div className="fs-4">
{totalOutward.toFixed(3)} MT
</div>
</div>
</div>

<div className="col">
<div className="alert alert-primary text-center fw-bold mb-0">
<div>Available Stock</div>
<div className="fs-4">
{availableStock.toFixed(3)} MT
</div>
</div>
</div>

<div className="col">
<div className="alert alert-secondary text-center fw-bold mb-0">
<div>Moisture Gain</div>
<div className="fs-4">
{moistureGain.toFixed(3)} MT
</div>
</div>
</div>

</div>


<table className="table table-bordered">

<thead className="table-primary">

<tr>
<th>Sl</th>
<th>Date</th>
<th>Client</th>
<th>Warehouse</th>
<th>Commodity</th>
<th>Variety</th>
<th>Trucks</th>
<th>Doc</th>
<th>BL / Vessel</th>
<th>Opening Bags</th>
<th>Opening MT</th>
<th>Inward Bags</th>
<th>Inward MT</th>
<th>Outward Bags</th>
<th>Outward MT</th>
<th>Closing Bags</th>
<th>Closing MT</th>
<th>Spillage</th>
<th>Remarks</th>
</tr>

</thead>

<tbody>

{filteredData.map((row,i)=>(

<tr key={i}>

<td>{i+1}</td>
<td>{row.date}</td>
<td>{row.companyName}</td>
<td>{row.warehouse}</td>
<td>{row.product}</td>
<td>{row.variety}</td>
<td>{row.totalTrucks}</td>
<td>{row.cddNo && row.cddNo!=="0" ? row.cddNo : row.crdNo}</td>
<td>{row.blVessel || ""}</td>
<td>{row.openingBags}</td>
<td>
{Number(row.openingStock || 0).toFixed(3)}
</td>
<td>{row.inwardBags}</td>
<td>{Number(row.inwardNetWt||0).toFixed(3)}</td>
<td>{row.outwardBags}</td>
<td>{Number(row.outwardNetWt||0).toFixed(3)}</td>
<td>{row.closingBags}</td>
<td>{Number(row.closingNetWt||0).toFixed(3)}</td>
<td>{row.spillageBag || 0}</td>
<td>{row.miscellaneous || ""}</td>
</tr>

))}

</tbody>

</table>

</div>


{/* BUTTONS */}

<div className="d-flex justify-content-end gap-2">

<button className="btn btn-secondary" onClick={handlePrint}>
Print
</button>

<button className="btn btn-success" onClick={handleExportExcel}>
Export Excel
</button>

<button className="btn btn-primary" onClick={handleClientReport}>
Client Report
</button>

</div>

</div>

);

}
